import type { Item } from "~/components/categorySwiper/CategorySwiper"
import { clsx } from "~/sdk/clx"
import type { ComponentSignal } from "~/sdk/signal"
import Image from "~/components/ui/Image"

interface Props {
    item: Item
    index: number
    slide: ComponentSignal<number>
    animate: ComponentSignal<boolean>
}

export default function SwiperItem({ item, index, slide, animate }: Props) {
    return (
        <a
            className={clsx(
                'bg-black ease-in-out flex flex-shrink-0 h-[9.6875rem] hover:bg-[#e5554f] [&_img]:hover:grayscale-[100%] items-center justify-center rounded-full transition duration-300 w-[9.6875rem] z-10',
                index !== slide.value && 'scale-[0.8] z-20',
                index !== slide.value ? 'opacity-50' : 'opacity-100',
                index !== slide.value &&
                    (index > slide.value ? '-translate-x-10' : 'translate-x-10'),
                !animate.value && 'transition-none',
            )}
            data-index={index}
            href={item.href}
            title={item.icon.alt}
            key={index}
            onClick={() => (slide.value = index)}
        >
            <Image
                alt={item.icon.alt}
                className='h-20 object-contain w-20'
                height={80}
                src={item.icon.src}
                width={80}
                loading='lazy'
            />
        </a>
    )
}
